import { stringify } from 'qs'

import { lsGet, safeAwait } from 'utils/request'

export const getPhotoClassifications = (props) => {
  return safeAwait(lsGet(`/photoClassifications?${stringify(props)}`))
}
